import React, { useEffect, useState } from 'react';
import { Navigate, NavLink } from 'react-router-dom';
import { useSession } from '../app/providers/SessionProvider.jsx';
import { filmmakerRequest } from '../services/business/businessService.js';
import '../styles/business.css';

const navItems = [
  ['/filmmakers/dashboard', 'Dashboard'], ['/filmmakers/titles', 'Titles'], ['/filmmakers/uploads', 'Delivery'],
  ['/filmmakers/revenue', 'Revenue'], ['/filmmakers/payouts', 'Payouts'], ['/filmmakers/messages', 'Messages'],
  ['/filmmakers/orders', 'Orders'], ['/filmmakers/profile', 'Profile'],
];

function money(value, currency = 'USD') {
  const number = Number(value || 0);
  return `${new Intl.NumberFormat('en-US', { style: 'currency', currency: String(currency || 'USD').toUpperCase() }).format(Number.isFinite(number) ? number : 0)}`;
}

function label(value) {
  return String(value || 'pending').replace(/[_-]+/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function FilmmakerOrdersPage() {
  const { ready, session, user } = useSession();
  const [orders, setOrders] = useState([]);
  const [status, setStatus] = useState('Loading creative orders…');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!session?.access_token) return;
    let active = true;
    filmmakerRequest('me', { session }).then((data) => {
      if (!active) return;
      setOrders(Array.isArray(data?.creative_orders) ? data.creative_orders : []);
      setStatus('');
    }).catch((err) => {
      if (!active) return;
      setStatus('');
      setError(err?.message || 'Creative orders could not be loaded.');
    });
    return () => { active = false; };
  }, [session?.access_token]);

  if (ready && !user) return <Navigate to={`/login?return=${encodeURIComponent('/filmmakers/orders')}`} replace />;

  return (
    <section className="business-page filmmaker-page">
      <header className="business-hero filmmaker-hero"><span className="eyebrow">WatchVIM Filmmaker Portal</span><h1>Creative Orders</h1><p>View service orders associated with your authenticated filmmaker account.</p></header>
      <nav className="business-subnav filmmaker-nav" aria-label="Filmmaker portal">{navItems.map(([to, text]) => <NavLink key={to} to={to}>{text}</NavLink>)}</nav>
      <div className="business-content">
        {status ? <p className="business-message" aria-busy="true">{status}</p> : null}
        {error ? <p className="business-message error" role="alert">{error}</p> : null}
        {!status && !error && !orders.length ? <div className="business-card"><h2>No creative orders yet</h2><p>Orders for filmmaker creative services will appear here when associated with this account.</p><NavLink to="/filmmakers/messages">Message WatchVIM</NavLink></div> : null}
        {orders.length ? <div className="business-card-grid two">{orders.map((order) => <article className="business-card" key={order.id}><div className="portal-card-heading"><div><span className="business-kicker">{label(order.status)}</span><h2>{order.service_name || label(order.service_code)}</h2></div><strong>{money(order.amount, order.currency)}</strong></div><p>{order.title_name ? `Title: ${order.title_name}` : 'General filmmaker service'}</p>{order.service_description ? <p>{order.service_description}</p> : null}<div className="portal-mini-stats"><span>Quantity <strong>{order.quantity || 1}</strong></span><span>Invoice <strong>{order.paypal_invoice_number || 'Pending'}</strong></span><span>Payment <strong>{label(order.paypal_invoice_status || order.status)}</strong></span></div>{order.paypal_invoice_url ? <a className="business-primary" href={order.paypal_invoice_url} target="_blank" rel="noreferrer">View PayPal Invoice</a> : null}</article>)}</div> : null}
      </div>
    </section>
  );
}
